import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/user';
import { isDefined } from '../../../../utils/variables';

export class UserServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async patchUserRequest(params: types.PatchUserRequestParameters): Promise<void> {
    const { data } = await this.axios.patch(`/v1/users/request/${params.path.token}`, params.body);
    return data;
  }

  async getCompanyAdminRequests(
    params: types.GetCompanyAdminRequestsParameters,
  ): Promise<types.GetCompanyAdminRequestsResponse> {
    const { data } = await this.axios.get(`/v1/users/company-admin-requests`);
    return data;
  }

  async getProjectUserRequests(
    params: types.GetProjectUserRequestsParameters,
  ): Promise<types.GetProjectUserRequestsResponse> {
    const { data } = await this.axios.get(`/v1/users/project-user-requests`);
    return data;
  }

  initiateAcceptUserInvitationProcessThroughSso(
    params: types.InitiateAcceptUserInvitationProcessThroughSsoParameters,
  ): Promise<void> {
    throw new Error(
      'This is not to be called from the client. Set windows.location.href to "getInitiateAcceptUserInvitationProcessThroughSso()" to redirect to Microsoft endpoint.',
    );
  }

  getInitiateAcceptUserInvitationProcessThroughSso(
    params: types.InitiateAcceptUserInvitationProcessThroughSsoParameters,
  ) {
    const url = new URL(this.axios.getUri());
    const isAWSDomain = url.hostname.includes('amazonaws.com');
    url.pathname = `${isAWSDomain ? '/Prod' : ''}/v1/users/invitation/sso/`;

    // Append query parameters to the URL
    if (isDefined(params.query)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.entries(params.query).forEach(([key, value]) => {
        if (isDefined(value)) {
          url.searchParams.append(key, String(value));
        }
      });
    }

    return url.toString();
  }
}
